import React, { useEffect, useState } from 'react';
import qs from 'qs';
import Cookie from 'js-cookie';
import { Form, Button, Toast, Dialog, Input } from 'antd-mobile';
import { useHistory } from 'react-router-dom';

export default (prop) => {
  const history = useHistory();
  const query = qs.parse(history.location.search, { ignoreQueryPrefix: true });
  const Sid = sessionStorage.getItem('_bl_sid');
  const Uid = Cookie.get('_bl_uid');
  const [envValue, setEnvValue] = useState(Cookie.get('env') || '--');

  useEffect(() => {
    document.title = '辅助信息';
  }, []);

  const accessToken = localStorage.getItem('accessToken') || '--';

  const onCopy = () => {
    const text = `Sid: ${Sid}\nUid: ${Uid}\nEnv: ${envValue}\nAccessToken: ${accessToken}\n`;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      const textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      textarea.style.position = 'fixed';
      textarea.style.clip = 'rect(0 0 0 0)';
      textarea.style.top = '10px';
      textarea.value = text;
      textarea.select();
      document.execCommand('copy', true);
      document.body.removeChild(textarea);
    }
    Toast.show({
      content: '复制成功',
      afterClose: () => {
        console.log('after');
      },
    });
  };

  const onEditEnv = () => {
    let tempEnvValue = envValue !== '--' ? envValue : '';
    Dialog.show({
      title: '修改环境变量',
      content: (
        <div style={{ padding: '12px 0' }}>
          <Input 
            placeholder="请输入新的env值"
            defaultValue={tempEnvValue}
            onChange={(val) => {
              tempEnvValue = val;
            }}
          />
        </div>
      ),
      closeOnAction: true,
      actions: [[
        {
          key: 'cancel',
          text: '取消',
        },
        {
          key: 'confirm',
          text: '确定',
          onClick: () => {
            if (tempEnvValue) {
              Cookie.set('env', tempEnvValue);
              setEnvValue(tempEnvValue);
            } else {
              Cookie.remove('env');
              setEnvValue('--');
            }
          }
        },
      ]],
    });
  };

  return (
    <div id="debug">
      <Form
        mode="card"
        footer={
          <Button
            block
            color="primary"
            onClick={() => {
              onCopy();
            }}
            size="large"
          >
            复制
          </Button>
        }
      >
        <Form.Header>辅助信息</Form.Header>
        <Form.Item label="Sid">
          <p>{Sid || '--'}</p>
        </Form.Item>
        <Form.Item label="Uid">
          <p>{Uid || '--'}</p>
        </Form.Item>
        <Form.Item 
          label="Env"
          extra={
            <Button
              size='small'
              onClick={onEditEnv}
            >
              编辑
            </Button>
          }
        >
          <p>{envValue}</p>
        </Form.Item>
        <Form.Item label="AccessToken">
          <p style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '100%' }}>{accessToken}</p>
        </Form.Item>
      </Form>
    </div>
  );
};
